module.exports = __webpack_public_path__ + "img/img-3-3mobile.d88a3e96.png";